import { GridusException } from './gridusException';

export class NotFoundException extends GridusException {
  constructor(message: string = 'Not Found') {
    super(message, 'F0001', 'error');
  }
}

export class UnAuthorizedException extends GridusException {
  constructor(message: string = 'Not Found') {
    super(message, 'A0001', 'error');
  }
}
